export const HOME_PATH = '/';
export const PROFILE_PATH = '/account';
export const HOTEL_SESSION_QUERY_PARAM = 'sessionId';
export const FLIGHT_SESSION_QUERY_PARAM = 'sid';
export const BOOKING_ID_QUERY_PARAM = 'bookingId';

export const CONFIRMATION_ACCESS = {
  WAIT: 'wait',
  SHOW: 'show',
  PROFILE: 'profile',
  LOGIN: 'login',
};
